import { useEffect, useState } from "react";
import CommunityImpactSection from "../../CommunityImpactSection";
import type { AreaModel } from "../../../types/Area";
import type { AreaAnalysisModel } from "../../../types/AreaAnalysis";
import type { OrganizationMapConfig } from "../../../commons/Constant";

type CommunityImpactTabProps = {
  areas: AreaModel[] | null;
  analysis: AreaAnalysisModel[] | null;
  organizationName: string;
  mapConfig?: OrganizationMapConfig;
  areasLoading?: boolean;
  areasError?: string | null;
  onRetryAreas?: () => void;
  analysisLoading?: boolean;
  analysisError?: string | null;
  onRetryAnalysis?: () => void;
  filterRevision: number;
};

export default function CommunityImpactTab({
  areas,
  analysis,
  organizationName,
  mapConfig,
  areasLoading = false,
  areasError,
  onRetryAreas,
  analysisLoading = false,
  analysisError,
  onRetryAnalysis,
  filterRevision,
}: CommunityImpactTabProps) {
  const [selectedDistrict, setSelectedDistrict] = useState<AreaModel | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    setSelectedDistrict(null);
  }, [filterRevision]);

  const handleRetryMap = () => {
    onRetryAreas?.();
    onRetryAnalysis?.();
  };

  return (
    <CommunityImpactSection
      areas={areas}
      analysis={analysis}
      organizationName={organizationName}
      mapConfig={mapConfig}
      isMapLoading={areasLoading || analysisLoading}
      mapError={areasError ?? analysisError ?? null}
      onRetryMap={handleRetryMap}
      selectedDistrict={selectedDistrict}
      onSelectDistrict={setSelectedDistrict}
      filterRevision={filterRevision}
      merchantSearchQuery={searchQuery}
      setMerchantSearchQuery={setSearchQuery}
    />
  );
}
